// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/auth/flow/AuthPageStyles.module.css';
import {AuthRouterLink} from '@app/features/auth/flow/AuthRouterLink';
import {Trans} from '@lingui/react/macro';

interface AuthBottomLinkProps {
	variant: 'login' | 'register';
	to: string;
}
export function AuthBottomLink({variant, to}: AuthBottomLinkProps) {
	return (
		<div className={styles.bottomLink}>
			<span className={styles.bottomLinkText}>
				{variant === 'login' ? <Trans>Already have an account?</Trans> : <Trans>Need an account?</Trans>}{' '}
			</span>
			<AuthRouterLink to={to} className={styles.bottomLinkAnchor}>
				{variant === 'login' ? <Trans>Log In</Trans> : <Trans>Register</Trans>}
			</AuthRouterLink>
		</div>
	);
}
interface AuthBottomLinksProps {
	children: React.ReactNode;
}
export function AuthBottomLinks({children}: AuthBottomLinksProps) {
	return <div className={styles.bottomLinks}>{children}</div>;
}
